<template>
  <page layout="tabbed">
    <page-header-new
      :title="$t('CustomerIntelligence_LifecycleReportingPage_Title')"
    >
      <template v-slot:actions>
        <date-filter @change="updateParams($event)" />
      </template>
    </page-header-new>

    <page-content>
      <form-section class="chart-wrapper" :title="title">
        <template v-slot:controls>
          <div class="graphTitle clearfix graph-controls">
            <span style="display:none;"></span>
            <div class="options clearfix timelineChart">
              <el-button class="opt2" icon="el-icon-upload2">
                {{ $t('CustomerIntelligence_LifecycleReportingPage_Export') }}
              </el-button>
              <el-select v-model="currentCategory" placeholder="Select">
                <el-option
                  v-for="item in metrics"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                />
              </el-select>
            </div>
          </div>
        </template>
        <line-chart-wrapper
          :chart-data="chartData"
          :options="chartOptions"
          style="height:340px"
        />
      </form-section>
      <metrics-block :metrics="metrics"></metrics-block>
    </page-content>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageContent from '@/common/components/page/PageContent'
import FormSection from '@/common/components/form/FormSection'
import DateFilter from '@/common/components/dashboard/DateFilter'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import moment from 'moment'
import { getDateFilterRange } from '@/core/helpers'
import LineChartWrapper from '@/modules/customer-intelligence/components/LineChartWrapper'
import MetricsBlock from '@/modules/customer-intelligence/components/MetricsBlock'

export default {
  name: 'LifecycleReportingPage',

  components: {
    FormSection,
    MetricsBlock,
    LineChartWrapper,
    PageHeaderNew,
    DateFilter,
    PageContent,
    Page
  },

  data() {
    return {
      currentCategory: 'churning',
      metrics: [
        {
          icon: 'sync',
          key: 'churning',
          value: 93028,
          label: 'Churning customers',
          up: true
        },
        {
          icon: 'user-risk',
          key: 'at_risk',
          value: 128203,
          label: 'At risk customers',
          up: true
        },
        {
          icon: 'heart',
          key: 'loyal',
          value: 482038,
          label: 'Loyal customers',
          up: false
        },
        {
          icon: 'star',
          key: 'high-value',
          value: 303204,
          label: 'High-value customers',
          up: false
        },
        {
          icon: 'user-check',
          key: 'new',
          value: 59293,
          label: 'New customers',
          up: false
        },
        {
          icon: 'graph-line',
          key: 'active',
          value: 647207,
          label: 'Active customers',
          up: true
        }
      ],
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        }
      },
      chartData: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        datasets: [
          {
            borderColor: '#1d87c8',
            backgroundColor: '#ffffff00',
            tension: 0,
            data: [150, 200, 350, 300, 210, 260, 250, 270, 490, 700, 520, 625]
          }
        ]
      }
    }
  },

  created() {
    let dateRange = getDateFilterRange()
    this.startDate = moment(dateRange.start).format('YYYY-MM-DD')
    this.endDate = moment(dateRange.end).format('YYYY-MM-DD')
  },

  methods: {
    updateParams(extraParams) {
      this.startDate = moment(extraParams.start).format('YYYY-MM-DD')
      this.endDate = moment(extraParams.end).format('YYYY-MM-DD')
    }
  },

  computed: {
    title() {
      return this.metrics.find(item => item.key === this.currentCategory).label
    }
  }
}
</script>

<style scoped>
>>> .graph-controls input {
  height: 36px;
}

>>> .graph-controls .el-select {
  margin-left: 10px;
}

>>> .header {
  border-bottom: 1px solid #ebeef5 !important;
}

>>> .page {
  min-height: 100%;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/customer-intelligence/pages/LifecycleReportingPage.vue